export default __webpack_public_path__ + "static/media/indra-otsutsuki.66a3d9f9.png";